import { useCallback, useEffect, useRef } from 'react';
import { AccountId, PermissionId, ProjectId } from 'api/models';
import { EventType, ProjectChannel, pushes, SocketData } from 'api/pushes';
import { useFilterEffect } from 'components/organisms/tasks/filters';
import { useAccount } from 'hooks/use-account';
import { useUser } from 'hooks/use-user';

// This file is used only for paginated all tasks page. We need to remove the other file and slowly migrate to this.
export const useMultiProjectWsUpdatesAllTasks = <T>(
  handler: (socketData: SocketData<T>) => void,
  [action, objectType]: EventType,
): ((projectIds: number[]) => void) => {
  const {
    permissions: { projects },
  } = useUser();
  const { accountId } = useAccount();
  const subscribeRef = useRef<any[]>([]);
  const getPairs = useCallback(
    (projectIds: number[]) =>
      projectIds
        .map(
          (projectId) =>
            [
              projectId,
              projects[projectId]?.permissionSet?.permissionSetId,
            ] as [number, number | undefined],
        )
        .filter(([, permissionId]) => permissionId != null)
        .map(([k, v]) => [k, v!]),
    [projects],
  );

  const socketSubscriber = useCallback(
    (newProjects: number[]) => {
      const subscriptions = getPairs(newProjects).map(
        ([projectId, permissionId]) =>
          pushes<T>(
            ProjectChannel(
              AccountId(accountId),
              PermissionId(permissionId),
              ProjectId(projectId),
            ),
            [action, objectType],
          ).subscribe(handler),
      );

      subscribeRef.current?.push(...subscriptions);
    },
    [accountId, action, objectType, handler, getPairs],
  );

  useFilterEffect(() => {
    subscribeRef.current.map((s) => s.unsubscribe());
    subscribeRef.current = [];
  });
  useEffect(() => {
    const ref = subscribeRef.current;

    return () => {
      ref.map((s) => s.unsubscribe());
    };
  }, []);

  return socketSubscriber;
};
